import React from "react";

function LiveMatchCard({ match, liveScore, odds }) {
    const formatTime = (startTime) => {
        if (!startTime) return "--:--";
        const date = new Date(startTime);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    if (!match) return null;

    const inningsLabel = liveScore?.inning === 2 ? "2nd Innings" : "1st Innings";

    const team1Score = liveScore?.inning === 2
        ? (liveScore?.inning1Score !== null && liveScore?.inning1Score !== undefined
            ? `${liveScore.inning1Score}/${liveScore.inning1Wickets}`
            : "—")
        : (liveScore ? `${liveScore.score ?? 0}/${liveScore.wicketCount ?? 0}` : "—");

    const team2Score = liveScore?.inning === 2
        ? (liveScore ? `${liveScore.score ?? 0}/${liveScore.wicketCount ?? 0}` : "—")
        : "—";

    const team1Overs = liveScore?.inning === 2 ? "" : (liveScore ? `${liveScore.over} ov` : "");
    const team2Overs = liveScore?.inning === 2 ? (liveScore ? `${liveScore.over} ov` : "") : "yet to bat";
    return (
        <div className="rcard">
            <div className="live-card-top-bar"></div>
            <div className="rcard-body">
                <div className="rcard-top">
                    <span className="fmt-tag">Virtual IPL · #{match.matchId}</span>
                    <span className="rbadge rb-live">● LIVE</span>
                </div>
                <div className="teams-line">
                    <div className="tblk">
                        <div className="tblk-logo">
                            {match.team1PicURL ? (
                                <img src={match.team1PicURL} alt={match.team1Name}
                                     className="tblk-img-sm"
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : <div className="tblk-emblem">🏏</div>}
                            <div>
                                <div className="tblk-name">{match.team1Name || "TBD"}</div>
                                <div className="tblk-score lv">{team1Score}</div>
                                <div className="tblk-ov">{team1Overs}</div>
                            </div>
                        </div>
                    </div>
                    <div className="cvs">VS</div>
                    <div className="tblk r">
                        <div className="tblk-logo tblk-logo-reverse">
                            {match.team2PicURL ? (
                                <img src={match.team2PicURL} alt={match.team2Name}
                                     className="tblk-img-sm"
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : <div className="tblk-emblem">🏏</div>}
                            <div>
                                <div className="tblk-name">{match.team2Name || "TBD"}</div>
                                <div className="tblk-score lo">{team2Score}</div>
                                <div className="tblk-ov">{team2Overs}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ball-rows-wrap">
                    <div className="ball-row-half">
                        {liveScore?.inning1Balls?.length > 0 && (
                            <div className="ball-row">
                                {liveScore.inning1Balls.slice(-6).map((ball, i) => {
                                    const outcome = ball.actionOutCome;
                                    let cls = "ball"; let label = "·";
                                    if (outcome === "FOUR_RUNS") { cls += " four"; label = "4"; }
                                    else if (outcome === "SIX_RUNS") { cls += " six"; label = "6"; }
                                    else if (outcome === "OUT") { cls += " wicket"; label = "W"; }
                                    else if (outcome === "NO_RUNS") { cls += " dot"; label = "·"; }
                                    else if (outcome === "WIDE") { cls += " dot"; label = "Wd"; }
                                    else if (outcome === "ONE_RUN") { cls += " run1"; label = "1"; }
                                    else if (outcome === "TWO_RUNS") { cls += " run2"; label = "2"; }
                                    else if (outcome === "THREE_RUNS") { cls += " run1"; label = "3"; }
                                    else { cls += " run1"; label = "?"; }
                                    return <div key={i} className={cls}>{label}</div>;
                                })}
                            </div>
                        )}
                    </div>
                    <div className="ball-row-half">
                        {liveScore?.inning2Balls?.length > 0 && (
                            <div className="ball-row">
                                {liveScore.inning2Balls.slice(-6).map((ball, i) => {
                                    const outcome = ball.actionOutCome;
                                    let cls = "ball"; let label = "·";
                                    if (outcome === "FOUR_RUNS") { cls += " four"; label = "4"; }
                                    else if (outcome === "SIX_RUNS") { cls += " six"; label = "6"; }
                                    else if (outcome === "OUT") { cls += " wicket"; label = "W"; }
                                    else if (outcome === "NO_RUNS") { cls += " dot"; label = "·"; }
                                    else if (outcome === "WIDE") { cls += " dot"; label = "Wd"; }
                                    else if (outcome === "ONE_RUN") { cls += " run1"; label = "1"; }
                                    else if (outcome === "TWO_RUNS") { cls += " run2"; label = "2"; }
                                    else if (outcome === "THREE_RUNS") { cls += " run1"; label = "3"; }
                                    else { cls += " run1"; label = "?"; }
                                    return <div key={i} className={cls}>{label}</div>;
                                })}
                            </div>
                        )}
                    </div>
                </div>

                {/* Batsman & Bowler */}
                {liveScore?.batsmanName && (
                    <div className="player-stats-bar">
                        <div className="player-stats-col">
                            <div className="player-stats-role">BATTING</div>
                            <div className="player-stats-name">{liveScore.batsmanName}</div>
                            <div className="player-stats-runs">
                                {liveScore.batsmanRuns}<span className="player-stats-balls"> ({liveScore.batsmanBalls})</span>
                            </div>
                        </div>
                        <div className="player-stats-divider"></div>
                        <div className="player-stats-col">
                            <div className="player-stats-role">BOWLING</div>
                            <div className="player-stats-name">{liveScore.bowlerName}</div>
                            <div className="player-stats-bowling">
                                {liveScore.bowlerWickets}/{liveScore.bowlerRuns}
                            </div>
                        </div>
                    </div>
                )}
                <div className="rcard-foot">
                    <span className="rf-result rf-result-live">🔴 In Progress · {inningsLabel}</span>
                    <span className="rf-date">Today {formatTime(match.matchStartTime)}</span>
                </div>
            </div>
        </div>
    );
}

export default LiveMatchCard;
